<template>
  <div class="page">
    <div class="top">
      <div class="title">当前可用积分</div>
      <div class="num-wrap">
        <van-icon
          v-if="bindFlag == '3'"
          class="icon-link m-white"
          name="info"
        />
        <div v-if="bindFlag == '3'" class="m-white t">已冻结</div>
        <div
          class="num"
          v-if="bindFlag == '1' || bindFlag == '3'"
          :class="{ grey: bindFlag == '3' }"
          v-text="pointStat.userPoint"
        ></div>
        <div class="o-info" v-if="bindFlag == '2' || bindFlag == '3'">
          <van-popover
            theme="dark"
            placement="bottom"
            v-model="bindInfoShow"
            trigger="click"
          >
            <div class="u-point-info">
              <div v-if="bindFlag == '1'">
                微信已绑定“图书馆微服务”，积分累计正常
              </div>
              <div v-if="bindFlag == '2'">
                微信未绑定“图书馆微服务”，尚未累计积分
              </div>
              <div v-if="bindFlag == '3'">
                微信已解绑“图书馆微服务”，积分累计停止
              </div>
            </div>
            <template #reference>
              <div class="info">
                <div class="status">
                  <div v-if="bindFlag == '1'">正常</div>
                  <div v-if="bindFlag == '2'">未启用</div>
                  <div v-if="bindFlag == '3'">已冻结</div>
                </div>
                <van-icon
                  v-if="bindFlag == '2'"
                  class="icon-link"
                  name="question"
                />
                <van-icon
                  v-if="bindFlag == '3'"
                  class="icon-link"
                  name="info"
                />
              </div>
            </template>
          </van-popover>
        </div>
      </div>
      <div class="btn-wrap">
        <div class="btn" @click="handleRouter('/integralRule')">
          <img class="icon" src="../assets/images/icon-guize.png" />
          <div class="text">积分规则</div>
        </div>
        <div class="btn" @click="handleRouter('/integralReport')">
          <img class="icon" src="../assets/images/icon-baobiao.png" />
          <div class="text">积分报表</div>
        </div>
      </div>
    </div>
    <div class="search-wrap">
      <div class="t">
        <div class="date-wrap">
          <!-- 选择时间 -->
          <van-dropdown-menu active-color="#1989fa">
            <van-dropdown-item
              v-model="timeValue"
              :options="timeOption"
              @change="changeTimeVal"
            />
          </van-dropdown-menu>
        </div>
        <div class="text-wrap">
          <div class="text mr">积分收入 {{ pointStat.incomePointValue }}</div>
          <div class="text">积分支出 {{ pointStat.expenditurePointValue }}</div>
        </div>
      </div>
      <!-- 自定义选择时间 -->
      <div v-if="timeShow" class="time">
        <div class="time-list">
          <div @click="startShow = true">{{ start ? start : "开始时间" }}</div>
          <span style="color: black"> ~ </span>
          <div @click="endShow = true">{{ end ? end : "结束时间" }}</div>
        </div>

        <van-button type="info" class="btn" @click="handleSelfPointQuery"
          >查询</van-button
        >
      </div>
      <van-popup v-model="startShow" position="bottom">
        <van-datetime-picker
          v-model="startTime"
          type="date"
          title="开始日期"
          @cancel="startShow = false"
          @confirm="handleStartConfirm"
        />
      </van-popup>
      <van-popup v-model="endShow" position="bottom">
        <van-datetime-picker
          v-model="endTime"
          type="date"
          title="结束日期"
          @cancel="endShow = false"
          @confirm="handleEndConfirm"
        />
      </van-popup>
      <div class="b">
        <van-tabs @click="handlePointType" color="#1989fa" class="tab-wrap">
          <van-tab name="0" class="tab" title="全部"></van-tab>
          <van-tab name="1" class="tab" title="收入"></van-tab>
          <van-tab name="2" class="tab" title="支出"></van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- 积分列表 -->
    <div class="list-wrap">
      <van-pull-refresh
        class="list-refresh"
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="handlePointDetail(false)"
          :immediate-check="false"
        >
          <div class="item" v-for="(item, index) in detailList" :key="index">
            <div class="text-wrap">
              <div class="text" v-text="item.detailComments"></div>
              <div class="date" v-text="item.insertTime"></div>
            </div>
            <div class="num" :class="item.pointType == '1' ? 'green' : 'red'">
              <span v-if="item.pointType == '1'">+</span
              ><span v-text="item.pointValue"></span>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { STATUS_CODE_OK, TOAST_STAY_TIME } from "@/config";
import { getPoint, getPointDetails, userPointSignGet } from "@/api/integral";
export default {
  name: "Integral",
  data() {
    return {
      bindInfoShow: false, // 绑定状态提示pop是否显示
      bindFlag: "1", // 公众号绑定状态
      pointStat: {},
      detailList: [], //积分明细
      time: [],
      timeShow: false,
      start: "", //自定义选择开始时间
      end: "", //自定义选择结束时间
      startTime: new Date(), //开始时间绑定值
      endTime: new Date(), //结束时间绑定值
      startShow: false,
      endShow: false,
      timeValue: 0, //快捷选项时间值
      timeOption: [
        {
          text: "最近一年",
          value: 0,
        },
        {
          text: "最近半年",
          value: 1,
        },
        {
          text: "最近三个月",
          value: 2,
        },
        {
          text: "最近一个月",
          value: 3,
        },
        {
          text: "自定义",
          value: 4,
        },
      ],
      pointType: "", //积分类型
      loading: false,
      finished: false,
      refreshing: false,
      currentPage: 1,
    };
  },
  created() {
    this.changeTimeVal(0);
    this.handleUserPointGet();
  },
  methods: {
    // 用户积分获取
    async handleUserPointGet() {
      const { data } = await userPointSignGet();
      if (data.code === STATUS_CODE_OK) {
        this.bindFlag = data.data.bindFlag;
      }
    },
    handleRouter(path) {
      this.$router.replace(path);
    },
    //选择时间
    changeTimeVal(value) {
      this.timeShow = false;
      this.startShow = false;
      this.endShow = false;
      this.start = "";
      this.end = "";
      let callData = true;
      if (value == 0) {
        this.time = [
          moment().add(-1, "year").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      }
      if (value == 1) {
        this.time = [
          moment().add(-6, "months").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      }
      if (value == 2) {
        this.time = [
          moment().add(-3, "months").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      }
      if (value == 3) {
        this.time = [
          moment().add(-1, "months").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      }
      if (value == 4) {
        this.time = [];
        this.timeShow = true;
        callData = false;
      }
      if (callData) {
        this.handlePoint();
        this.handlePointDetail(true);
      }
    },
    //选择开始日期
    handleStartConfirm(value) {
      const time = moment(value).format("YYYY-MM-DD");
      if (
        this.end &&
        moment(time, "YYYY-MM-DD").isAfter(moment(this.end, "YYYY-MM-DD"))
      ) {
        this.$notify({
          type: "warning",
          message: "开始日期不能在结束日期之后",
          duration: TOAST_STAY_TIME,
        });
        return;
      } else {
        this.startShow = false;
        this.start = time;
      }
    },
    //选择结束日期
    handleEndConfirm(value) {
      const time = moment(value).format("YYYY-MM-DD");
      if (
        this.start &&
        moment(time, "YYYY-MM-DD").isBefore(moment(this.start, "YYYY-MM-DD"))
      ) {
        this.$notify({
          type: "warning",
          message: "结束日期不能再开始日期之前",
          duration: TOAST_STAY_TIME,
        });
        return;
      } else {
        this.endShow = false;
        this.end = time;
      }
    },
    //获取用户积分
    async handlePoint() {
      const { data } = await getPoint({
        startTime: this.time[0],
        endTime: this.time[1],
      });
      if (data.code === STATUS_CODE_OK) {
        this.pointStat = data.data;
      }
    },
    //选择收入支出全部
    handlePointType(name) {
      if (name == "1") {
        this.pointType = 1;
      } else if (name == "2") {
        this.pointType = 2;
      } else {
        this.pointType = "";
      }
      this.handlePointDetail(true);
    },
    // 自定义查询
    handleSelfPointQuery() {
      if (!this.start) {
        this.$notify({
          type: "warning",
          message: "请选择开始日期",
          duration: TOAST_STAY_TIME,
        });
        return;
      }
      if (!this.end) {
        this.$notify({
          type: "warning",
          message: "请选择结束日期",
          duration: TOAST_STAY_TIME,
        });
        return;
      }
      this.time = [this.start, this.end];
      this.handlePoint();
      this.handlePointDetail(true);
    },

    //获取用户积分明细
    async handlePointDetail(isReFresh = false) {
      if (isReFresh) {
        this.currentPage = 1;
      }
      const { data } = await getPointDetails({
        pointType: this.pointType,
        startTime: this.time[0],
        endTime: this.time[1],
        pageNo: this.currentPage,
        pageSize: 20,
      });
      if (data.code === STATUS_CODE_OK) {
        if (isReFresh) {
          this.detailList = data.data.pageInfo;
        } else {
          this.detailList = this.detailList.concat(data.data.pageInfo);
        }
        this.refreshing = false;
        this.loading = false;
        if (data.data.hasMore == "N") {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.currentPage++;
      }
    },

    //上拉刷新
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.handlePointDetail(true);
    },
  },
};
</script>

<style lang="scss">
.u-point-info {
  font-size: 12px;
  padding: 6px 12px;
  width: 180px;
}
</style>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  display: flex;
  flex-direction: column;
  .top {
    background-color: #3770d3;
    color: #fff;
    padding: 15px 0;
    .title {
      text-align: center;
      font-size: 16px;
    }
    .num-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 3px;
      .m-white {
        visibility: hidden;
        &.icon-link {
          margin: 0 1px 0 10px;
        }
        &.t {
          padding-right: 10px;
        }
      }
      .num {
        color: #fff;
        font-size: 18px;
        &.grey {
          color: #ccc;
        }
      }
      .o-info {
        display: flex;
        align-items: center;
        .info {
          display: flex;
          align-items: center;
          padding: 0 10px;
          cursor: pointer;
          .status {
            color: #ccc;
          }
          .icon-link {
            color: #ccc;
            font-size: 14px;
            margin-left: 2px;
          }
        }
      }
    }
    .btn-wrap {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        display: flex;
        align-items: center;
        padding: 6px 12px;
        border-radius: 20px;
        border: 1px solid #fff;
        margin: 0 20px;
        font-size: 12px;
        cursor: pointer;
        .icon {
          width: 15px;
          height: 15px;
          display: block;
          margin-right: 5px;
        }
      }
    }
  }

  .search-wrap {
    background-color: #fff;
    .t {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      .date-wrap {
        ::v-deep .van-dropdown-menu__bar {
          box-shadow: none;
        }
      }
      .text-wrap {
        display: flex;
        color: #999;
        .mr {
          margin-right: 15px;
        }
      }
    }
    .time {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #999;
      .time-list {
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          width: 120px;
          text-align: center;
        }
      }
      .btn {
        width: 60px;
        height: 20px;
        padding: 15px 10px;
        border-radius: 10px;
      }
    }
    .overlay {
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .van-picker {
      width: 100%;
    }
    .b {
      padding: 3px 0 10px 0;
      display: flex;
      .van-tabs {
        flex: 1;
      }
    }
  }
  .list-wrap {
    margin-top: 10px;
    background-color: #fff;
    padding: 5px 0;
    flex: 1;
    overflow: hidden;
    .list-refresh {
      height: 100%;
      overflow-y: auto;
    }
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 10px;
      border-bottom: 1px solid #eee;
      &:last-child {
        border-bottom: 1px solid transparent;
      }
      .text-wrap {
        flex: 1;
        .date {
          color: #999;
          font-size: 12px;
        }
      }
      .num {
        font-size: 16px;
        color: #000;
        &.green {
          color: #07c160;
        }
        &.red {
          color: #ee0a24;
        }
      }
    }
    .empty {
      background-color: #fff;
    }
  }
}
</style>
